import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useEffect,
  useRef
} from "react";
import { Link } from "react-router-dom";
import {
  Drawer,
  Button,
  Input,
  notification,
  Space,
  Upload,
  Typography,
  Divider, 
  Tooltip,
  Menu,
  Dropdown, 
  Row, 
  Col
} from "antd";
import { useSelector } from 'react-redux';
import { CopyOutlined, MoreOutlined } from "@ant-design/icons";
import documentManagementAPI from '../../../restAPI/DocumentManagement';
import ShareDocument from './ShareDocument';

const {Text, Paragraph } = Typography;
const Context = React.createContext({
  name: "Default",
});
const StepForm = forwardRef((props, ref) => {
  const {record} = props;
  console.log("view record ", record)
  const [selectedRecord, setSelectedRecord] = useState({});
  const [cancelRecord, setCancelRecord] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const [viewData, setViewData] = useState({});
  const { token } = useSelector(state => state.auth);
  const { Dragger } = Upload;
  const [attachments, setAttachments] = useState([]);
  const [toEmails, setToEmails] = useState(['buyer@gmail.com']);
  const [isShareOpen,setIsShareOpen] = useState(false); //  to show the share screen when selected
  const [isModalVisible, setIsModalVisible] = useState(false);
  const shareDocumentRef = useRef(null);
  

  const handleCopyUrl = async (url) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
      } else {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      notification.success({
        message: 'URL Copied',
        description: 'The URL has been successfully copied to your clipboard.',
        placement: 'bottomLeft',
      });
    } catch (err) {
      notification.error({
        message: 'Failed to copy',
        description: 'Failed to copy URL to clipboard.',
        placement: 'bottomLeft',
      });
      console.error('Failed to copy:', err);
    }
  };
    // Expose methods to the parent component
    useImperativeHandle(ref, () => ({
      openDrawer: (record) => {
        getViewData(token,record)
        setSelectedRecord(record);
        console.log("view data imparative", record)
        setVisible(true); // Open drawer
      },
      closeDrawer: () => {
        viewData({});
        setSelectedRecord({});
        setCancelRecord([])
        setVisible(false); // Close drawer
      },
    }));

    useEffect(() => {
      if (!visible) {
        setViewData({});
        setSelectedRecord({});
        setAttachments([]);
        setToEmails(['buyer@gmail.com']);
        setCurrentStep(0);
      }
    }, [visible]);

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
  });
  };
// ------------------------------------------------------------------------------hanle the share drawer events--------------------------------------------------------------
const shareDocumentDrawer = (record) => {
  setIsShareOpen(true);
  if (shareDocumentRef.current) {
    
    shareDocumentRef.current.openDrawer(record);
  }
};

const closeSshareDocumentDrawer = () => {
  setIsShareOpen(false); 
};
//---------------------------------------------------------------------------End of Shre drawer------------------------------------------

  const getViewData = async (token ,record) =>{
      const formData = new FormData();
  
      formData.append("MOGU_UUID", record?.documentMoguID);
      formData.append("TPS_Id", record?.tPS_Id !== undefined ? record?.tPS_Id :"");
  
      await documentManagementAPI.GetViewData(
            token,
            localStorage.getItem("groupId"), 
            localStorage.getItem("companyId"),
            formData
          )
          .then((response) => {
            console.log('response status response',JSON.stringify(response.data));
          const modifiedDate = formatDate(response.data.GeneralInformation?.InvoiceDateTime);
          if (response.data.GeneralInformation) {
            response.data.GeneralInformation.InvoiceDateTime = modifiedDate;
          }
          const netAmount = parseFloat(response.data?.GeneralInformation?.InvoiceTotalNetAmount).toLocaleString('en-US', { minimumFractionDigits: 2 }) + " " + response.data?.GeneralInformation?.Currency;
          if (response.data.GeneralInformation) {
            response.data.GeneralInformation.InvoiceTotalNetAmount = netAmount;
          }
          setViewData(response.data);
        })
        .catch((err) => {
          console.log('err',err)
          if (err.response) {
            openNotificationWithIcon(
              "error",
              "Retrieve Status Trail",
              `${err.response.data.message}`,
              "bottomLeft"
            );
          } else {
            console.log('err else',err)
            openNotificationWithIcon(
              "error",
              "Retrieve Status Trail",
              `${err.message}`,
              "bottomLeft"
            );
          }
        });
    }

    const handleDownloadPDFWithQR= (record) =>{
            
          console.log("record?.documentMoguID",record?.documentMoguID)
          console.log("record?.tPS_Id",record?.tPS_Id)
          const formData = new FormData();
    
          formData.append("groupId", localStorage.getItem("groupId"));
          formData.append("companyId", localStorage.getItem("companyId"));
          formData.append("MOGU_UUID", record?.documentMoguID);
          formData.append("TPS_Id", record?.tPS_Id);
    
          documentManagementAPI.downloadPDFWithQR(token,formData)
            .then((response) => {
              //console.log('response',response)
              // openNotificationWithIcon(
              //   "success",
              //   "Successful",
              //   `${response.message}`,
              //   "bottomLeft"
              // );
            })
            .catch((err) => {
             
              if (err.response) {
                openNotificationWithIcon("error","Download Original File Failed",`${err.response.data.message}`, "bottomLeft");
              } else {
                
                openNotificationWithIcon("error","Download Original File Failed",`${err.message}`,"bottomLeft");
              }
            });
        }

  const formatDate = (datetring) => {
    const date = new Date(datetring);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-based
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    
    return `${day}-${month}-${year} ${hours}:${minutes}`;
};

  const formatAddress = (address) => {
    if (!address) return '';
    
    const parts = [];
    
    if (address.addressLine1) parts.push(address.addressLine1);
    if (address.addressLine2) parts.push(address.addressLine2);
    if (address.addressLine3) parts.push(address.addressLine3);
    
    const cityStatePostal = [];
    if (address.city) cityStatePostal.push(address.city);
    
    if (address.state) {
      const state = address.state.code || address.state.name;
      if (state) cityStatePostal.push(state);
    }
    
    if (address.postalZone) cityStatePostal.push(address.postalZone);
    
    if (cityStatePostal.length > 0) {
      parts.push(cityStatePostal.join(' '));
    }
    
    return parts.join(', ');
  };


  const [api, contextHolder] = notification.useNotification();
  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  const menuItems = (selectedRecord) => {

        return [
          { key: "downloadPdf", label: "Download PDF" , onClick: () =>handleDownloadPDFWithQR(selectedRecord) },//onClick: () =>handleDownloadPDF(record) }:null, onClick:() =>showSingleCancelModal(record)
          { key: "share", label: "Share" , onClick:() => shareDocumentDrawer(selectedRecord)},
        ].filter(Boolean);
  };

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer

        title={
          <div justify="space-between" align="left">

          <span style={{ position: 'relative', top: '5px' }}>View Document Summary</span>
          <Dropdown
            overlay={
              <Menu>
                {menuItems(selectedRecord).map((item) => (
                  <Menu.Item
                    key={item.key}
                    onClick={item.onClick}
                    disabled = {selectedRecord?.status?.toLowerCase() !== "success"} 
                  >
                    {item.link ? (
                      <Link to={item.link}>{item.label}</Link> 
                    ) : (
                      item.label
                    )}
                  </Menu.Item>
                ))}
              </Menu>
            }
            trigger={["click"]}
          >
            <Button style={{ float: 'right' }}>
                Options
                <MoreOutlined style={{ marginLeft: 8 }} />
              </Button>
          </Dropdown>
          </div>
        }
        width={700}
        visible={visible}
        onClose={() => setVisible(false)}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large" onClick={() => setVisible(false)}>
              Exit
            </Button>


          </div>
        }
      >
        {viewData &&
        <div style={{ marginTop: 4 }}>

          {/* Section 1 */}
          <Divider style={{ borderColor: '#7cb305' }}>General Information</Divider>
          <Row gutter={[16, 16]}>
            <Col span={10}>
              <Text strong>Invoice Number:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.InvoiceNumber}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Cancellation Countdown:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.CancellationCountdown}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Document Type:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>Invoice</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Classification:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.Classification}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Invoice Date & Time:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.InvoiceDateTime}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Currency:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.Currency}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Invoice Total Net Amount:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.GeneralInformation?.InvoiceTotalNetAmount}</Paragraph>
            </Col>
          </Row>

          <Divider style={{ borderColor: '#7cb305' }}>Supplier Details</Divider>
          <Row gutter={[16, 16]}>
            <Col span={10}>
              <Text strong>Name:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.SupplierDetails?.Name}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>TIN:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.SupplierDetails?.Tin}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Address:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>
              {formatAddress(viewData?.SupplierDetails?.Address) }
              </Paragraph>
            </Col>
          </Row>

          <Divider style={{ borderColor: '#7cb305' }}>Buyer Details</Divider>
          <Row gutter={[16, 16]}>
            <Col span={10}>
              <Text strong>Name:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.BuyerDetails?.Name}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>TIN:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>{viewData?.BuyerDetails?.Tin}</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>Address:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>
              {formatAddress(viewData?.BuyerDetails?.Address) }
              </Paragraph>
            </Col>
          </Row>

          <Divider style={{ borderColor: '#7cb305' }}>LHDN</Divider>
          <Row gutter={[16, 16]}>
            <Col span={10}>
              <Text strong>Status:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>Success</Paragraph>
            </Col>

            <Col span={10}>
              <Text strong>LHDN Response:</Text>
            </Col>
            <Col span={14}>
              <Paragraph style={{ marginBottom: '8px' }}>
                Description: Successful transaction or request completed successfully.
              </Paragraph>
            </Col>
          </Row>

          <Divider />
          {/* Section 5 */}
          <Space direction="vertical" size="small" style={{ width: '100%' }}>

            <Text strong>URL:</Text>
            <Input
              value={viewData?.LHDNInformation?.URL}
              readOnly
              addonAfter={
                <Tooltip title="Copy URL">
                  <CopyOutlined onClick={() => handleCopyUrl(viewData?.LHDNInformation?.URL)} style={{ cursor: 'pointer' }} />
                </Tooltip>
              }
              style={{
                borderColor: '#d9d9d9',
                borderRadius: '4px',
                marginBottom: '8px',
              }}
              onClick={(e) => e.target.select()}
            />
          </Space>
        </div>
        }
      </Drawer>
      <ShareDocument ref={shareDocumentRef} open={isShareOpen} onClose={closeSshareDocumentDrawer} record={selectedRecord}/>
    </Context.Provider>
  );
});

export default StepForm;
